import React, { Fragment } from 'react';
import { Container, Row, Col, Button, Table } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ItemBox from '../../../components/itens/item';


function ExpoMacuco2025Screen() {
    return (
        <Fragment>
            <Head titulo="Transparência da Expo Macuco 2025" />
            <Header />
            <Container>
                <Row>
                    <Col xs={12}> <h2 style={{ textAlign: 'center' }}>Prestação de Contas da Expo Macuco 2025</h2>
                        <p style={{ textAlign: 'center' }}>A XVII edição da Expo Macuco terá entrada gratuita para todos shows, com as seguintes atrações:</p>
                    </Col>
                </Row>
                <br />
                <br />
                <Fragment>
                    <h2>Programação:</h2>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th><h5>Dia</h5></th>
                                <th><h5>Horário</h5></th>
                                <th><h5>Descrição</h5></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><p>11/09/2025 - Quinta-feira</p></td>
                                <td><p>22h</p></td>
                                <td><p>Mumuzinho</p></td>
                            </tr>
                             <tr>
                                <td><p>12/09/2025 - Sexta-feira</p></td>
                                <td><p>22h</p></td>
                                <td><p>Nadson o Ferinha</p></td>
                            </tr>
                             <tr>
                                <td><p>13/09/2025 - Sábado</p></td>
                                <td><p>22h</p></td>
                                <td><p>Diego & Victor Hugo</p></td>
                            </tr>
                             <tr>
                                <td><p>14/09/2025 - Domingo</p></td>
                                <td><p>22h</p></td>
                                <td><p>Simone Mendes</p></td>
                            </tr>
                        </tbody>
                    </Table>
                    <br/>
                    <Row xs={12} lg={2}>
                        <Col>
                            <ItemBox
                                titulo={"Contratos Expo Macuco 2025"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem de contratos firmados por essa prefeitura para realização da Exposição Agropecuária de Macuco em 2025.</p><br /></Fragment>}
                                awesome={"faFileSignature"}
                                link={"../contratos/expomacuco/2025"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Licitações/Dispensas Expo Macuco 2025"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem de licitações e dispensas realizadas por essa prefeitura para realização da Exposição Agropecuária de Macuco em 2025.</p><br /></Fragment>}
                                awesome={"faStore"}
                                link={"../licitacao/expomacuco/2025"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Legislação da Expo Macuco 2025"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem de leis e decretos publicados por essa prefeitura para realização da Exposição Agropecuária de Macuco em 2025.</p><br /></Fragment>}
                                awesome={"faScaleBalanced"}
                                link={"../diario/expomacuco/2025"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Outras publicações Expo Macuco 2025"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem de outras publicações feitas por essa prefeitura a respeito da Exposição Agropecuária de Macuco em 2025.</p><br /></Fragment>}
                                awesome={"faBullhorn"}
                                link={"../expomacuco/2025/publicacoes"}
                            />
                        </Col>
                        <br />
                    </Row>
                    <Row xs={1}>
                        <Col xs={{ span: 2, offset: 11 }}>
                            <Link to='/expomacuco'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </Fragment>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ExpoMacuco2025Screen;